import type { hc } from 'hono/client';
import type { AppType } from '@like-aiop/backend/src/app';

const refreshSession = async (publicClient: ReturnType<typeof hc<AppType>>): Promise<string> => {
  const res = await publicClient.auth.refresh.$post();
  if (!res.ok) {
    throw new Error('refresh failed status ' + String(res.status));
  }
  const data = (await res.json()) as { accessToken?: string };
  if (!data.accessToken) throw new Error('refresh missing accessToken');
  return data.accessToken;
};

export default refreshSession;
